import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Send, Mail } from "lucide-react";
import api from "@/api/client";

/** Small dialog + button to email a pickup request to a courier contact. */
export default function PickupRequestButton({ parcel, testid = "pickup-btn" }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    if (!email) return toast.error("Courier email required");
    setBusy(true);
    try {
      const { data } = await api.post(`/parcels/${parcel.id}/pickup`,
        { courier_email: email, contact_name: name });
      if (data.email_sent) toast.success("Pickup request emailed");
      else toast.warning("Saved but email delivery could not be confirmed");
      setOpen(false); setEmail(""); setName("");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button
        type="button"
        data-testid={testid}
        onClick={() => setOpen(true)}
        variant="outline"
        className="rounded-md text-xs"
      >
        <Mail size={14} className="mr-2" /> Notify pickup
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-md max-w-md">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">Email pickup to courier</DialogTitle>
          </DialogHeader>
          <div className="space-y-3">
            <div className="text-sm text-muted-foreground border border-border rounded-md p-2 bg-muted/40">
              Sends a formatted pickup request for <b className="text-foreground">{parcel?.tracking_number}</b>
              {" "}via <b className="text-foreground">{parcel?.courier}</b>.
            </div>
            <label>
              <span className="overline">Courier email *</span>
              <Input data-testid="pickup-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)}
                className="mt-1 rounded-md" placeholder="ops@delhivery.com" />
            </label>
            <label>
              <span className="overline">Contact name (optional)</span>
              <Input data-testid="pickup-name" value={name} onChange={(e)=>setName(e.target.value)}
                className="mt-1 rounded-md" placeholder="Delhivery pickup team" />
            </label>
            <Button type="button" data-testid="pickup-send" onClick={send} disabled={busy}
              className="w-full rounded-md bg-primary text-primary-foreground shadow-brut-orange">
              <Send size={14} className="mr-2" /> {busy ? "Sending…" : "Send email"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
